<template>
    <b-modal
        v-model="config.model"
        :centered="config?.centered ?? false"
        :size="config?.size ?? 'xl'"
        :no-close-on-backdrop="config?.noCloseOnBackdrop ?? true"
        :no-close-on-esc="config?.noCloseOnEsc ?? false"
        :id="id + '-modal'"
        :title="config?.title ?? ''"
        :scrollable="config?.scrollable ?? false"
        :hide-footer="config?.hideFooter ?? false"
        :dialog-class="`custom-modal ${config?.class ?? ''}`"
        @hide="handleOnHide"
    >
        <template #modal-header>
            <h5 id="modal-footer-lg___BV_modal_title_" class="modal-title">{{ config?.title ?? '' }}</h5>
            <button v-if="!config || !config.hideCloseButton" type="button" aria-label="Close" class="close" @click="handleCloseModal">×</button>
        </template>
        <b-container fluid>
            <slot />
        </b-container>
        <template #modal-footer>
            <div>
                <button type="button" class="btn btn-common-cancel mr-3" @click="handleCloseModal">
                    {{ config?.titleBtnCancel ? config.titleBtnCancel : $t('btn.cancel') }}
                </button>
                <template v-if="!isView">
                    <button v-if="config?.titleBtnSave == $t('btn.register')" type="button" class="btn btn-common btn-primary" @click="handleSave">
                        <i class="ri-file-add-line"></i>{{ $t('btn.register') }}
                    </button>
                    <button v-else type="button" class="btn btn-common btn-success" @click="handleSave">
                        {{ config?.titleBtnSave ? config.titleBtnSave : $t('btn.save') }}
                    </button>
                </template>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'ModalCommon',
    components: {},
    props: {
        id: {
            type: String,
            required: false,
            default: ''
        },
        config: {
            type: Object,
            required: true,
            default: () => ({
                title: '',
                model: false,
                scrollable: false,
                hideFooter: false,
                noCloseOnBackdrop: true,
                noCloseOnEsc: false,
                centered: false,
                size: 'xl',
                class: '',
                titleBtnCancel: this.$t('btn.cancel'),
                titleBtnSave: this.$t('btn.save'),
                validate: false
            })
        },
        isView: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    methods: {
        handleCloseModal() {
            this.config.model = false;
            this.$emit('close');
        },

        handleSave() {
            if (this.config?.validate == false || !this.config?.validate) this.config.model = false;
            this.$emit('save');
        },

        handleOnHide(evt) {
            if (!this.$props.config.noCloseOnBackdrop) {
                if (evt.trigger === 'backdrop') {
                    evt.preventDefault();
                    this.config.model = false;
                    this.$emit('close');
                }
            }
        }
    },
    watch: {}
};
</script>

<style lang="scss">
.custom-modal {
    .modal-content {
        .modal-footer {
            justify-content: center;
        }
    }
    &.h-25 {
        height: 25vh;
    }
    &.h-30 {
        height: 30vh;
    }
    &.h-35 {
        height: 35vh;
    }
    &.h-40 {
        height: 40vh;
    }
    &.h-45 {
        height: 45vh;
    }
    &.h-50 {
        height: 50vh;
    }
    &.h-55 {
        height: 55vh;
    }
    &.h-60 {
        height: 60vh;
    }
    &.h-65 {
        height: 65vh;
    }
    &.h-70 {
        height: 70vh;
    }
    &.h-75 {
        height: 75vh;
    }
    &.h-80 {
        height: 80vh;
    }
    &.h-85 {
        height: 85vh;
    }
    &.h-90 {
        height: 90vh;
    }
    &.h-95 {
        height: 95vh;
    }
    &.h-100 {
        height: 100vh;
    }
}
</style>
